<template>
	<t-dropdown :options="options" trigger="hover" @click="clickHandler" placement="bottom-right">
		<t-button class="dropdown-button" variant="text">
			<template #icon><t-icon name="user" /></template>
			{{ userInfo?.name || '用户' }}
			<template #suffix> <t-icon name="chevron-down" size="16" /></template>
		</t-button>
	</t-dropdown>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import useStore from '@/store'
import { useRouter } from 'vue-router'
import { DialogPlugin } from 'tdesign-vue-next'

const { user } = useStore()
const router = useRouter()

const userInfo = computed(() => {
	return user.userInfo
})

const options = [
	// { content: '个人资料', value: 1, divider: true },
	{ content: '退出登录', value: 2, theme: 'error' },
]

const clickHandler = (data: any) => {
	switch (data.value) {
		case 1:
			router.push('/personal/index')
			break
		case 2:
			logout()
			break
	}
}

function logout() {
	const dialog = DialogPlugin.confirm({
		header: '提示',
		body: '确定退出登录吗？',
		closeOnOverlayClick: false,
		closeOnEscKeydown: false,
		onConfirm: () => {
			dialog.destroy()
			user.removeAll()
			router.push('/login')
		},
		onCancel: () => {
			dialog.destroy()
		},
	})
}
</script>

<style lang="scss" scoped>
.dropdown-button {
	color: #fff;

	&:hover {
		color: var(--td-brand-color-active);
	}
}
</style>
